const transferBaseUrl = `${process.env.REACT_APP_GATEWAY_BASE_URL}/transaction/api/v2`;
const onboardingUrl = `${process.env.REACT_APP_GATEWAY_BASE_URL}/onboarding/api/v2`;
const kycUrl = `${process.env.REACT_APP_GATEWAY_BASE_URL}/kyc-v2/api/v1`;
const norebaseUrl = `${process.env.REACT_APP_NOREBASE_BASE_URL}`;
const openApiBaseUrl = `${process.env.REACT_APP_OPENAPI_URL}`;
const gatewayBaseUrl = `${process.env.REACT_APP_GATEWAY_BASE_URL}`;
const openApiOnboardingBaseUrl = `${gatewayBaseUrl}/onboarding/api/v2/OpenApi`;
const businessRegistrationBaseUrl = `${gatewayBaseUrl}/business-reg/api/v2/business-registration`;

export const urls = {
    // USERS/ONBOARDING
    validateCustomer: `${onboardingUrl}/User/ValidateCustomer`,
    validateToken: `${onboardingUrl}/User/ValidateEmailToken`,
    create: `${onboardingUrl}/User/Create`,
    retrieveUserCustomerAccounts: `${onboardingUrl}/User/RetrieveUserCustomerAccounts`,
    verifyPhoneNumber: `${onboardingUrl}/User/SendPhonenumberConfirmationTokenAsync`,
    vaidatePhoneNumberChange: `${onboardingUrl}/User/ValidatePhoneNumberToken`,
    retrieveUserCustomerAccounts2: `${onboardingUrl}/User/RetrieveUserCustomerAccounts2`,
    validateRetailCustomer: `${onboardingUrl}/User/ValidateCustomer`,
    sendValidationToken: `${onboardingUrl}/User/SendValidationOtp`,
    sendSMSNINOtp: `${onboardingUrl}/User/SendSMSNINOtp`,
    validateSMSNINOTP: `${onboardingUrl}/User/ValidateSMSNINOTP`,
    validateTokenAndCreateProfile: `${onboardingUrl}/User/ValidateTokenAndCreateProfile`,
    retrieveSMEProfile: `${onboardingUrl}/User/RetrieveSMEProfiles`,
    createUserWithoutToken: `${onboardingUrl}/User/ValidateCustomerWithoutToken`,
    updateNokDetails: `${onboardingUrl}/User/UpdateNextOfKin`,
    uploadUserFile: `${onboardingUrl}/User/uploadUserFile`,
    uploadUserFileImage: `${onboardingUrl}/User/UploadUserFile`,
    updateUserInfo: `${onboardingUrl}/User/Update`,
    updateUserAddress: `${onboardingUrl}/User/address`,
    retrieveGroups: `${onboardingUrl}/User/RetrieveUserGroups`,
    createAdditionalBusiness: `${onboardingUrl}/User/CreateAdditionalBusiness`,
    initiatePasswordReset: `${onboardingUrl}/User/InitiatePasswordReset`,
    validatePasswordReset: `${onboardingUrl}/User/ValidateResetPasswordToken`,
    validatePhoneNumberAndDOB: `${onboardingUrl}/User/ValidatePhoneNumberAndDOB`,
    resetPassword: `${onboardingUrl}/User/ValidateOTPAndResetPassword`,
    validateLoginToken: `${onboardingUrl}/User/ValidateLoginToken`,
    loginUser: `${onboardingUrl}/User/Authenticate`,
    refreshToken: `${onboardingUrl}/User/RefreshToken`,
    ssoLoginUser: `${onboardingUrl}/User/Login`,
    sendLoginValidationToken: `${onboardingUrl}/User/SendLoginValidationOtp`,
    validateLogin: `${onboardingUrl}/User/ValidateLogin`,
    validateTransactionPinAndResetPasssword: `${onboardingUrl}/User/ValidateTransactionPinAndResetPassword`,
    sendPhoneNumberResetOtp: `${onboardingUrl}/User/SendSMSOtpToResetPassword`,
    validateDobAndResetPassword: `${onboardingUrl}/User/ValidateDateOfBirthAndResetPassword`,
    ntbEmailVerification: `${onboardingUrl}/User/SendEmailOtp`,
    ntbValidateEmailOtp: `${onboardingUrl}/User/ValidateOnboardingEmailOtp`,
    ntbCreateAccount: `${onboardingUrl}/User/Create`,
    ntbSendSMSOtp: `${onboardingUrl}/User/SendSMSOtp`,
    ntbLoginUser: `${onboardingUrl}/User/Login/KudaBusiness`,
    ntbAddBvn: `${onboardingUrl}/User/AddUserBVN`,
    ntbUpdateMatiFlag: `${onboardingUrl}/User/UpdateMatiVerification`,
    updateMatiVerificationAsync: `${onboardingUrl}/User/UpdateMatiVerificationAsync`,
    verificationCancelledAsync: `${onboardingUrl}/User/VerificationCancelledAsync`,
    receiveBvnAuthorizationCode: `${onboardingUrl}/User/ReceiveBvnAuthorizationCode`,
    updatePEPStatus: `${onboardingUrl}/User/UpdatePEPStatus`,
    updateSignatoryAddress: `${onboardingUrl}/User/UpdateSignatoryAddress`,
    ntbinitiateNIN: `${onboardingUrl}/User/InitiateNin`,
    keycloakLogout: `${onboardingUrl}/User/Logout`,
    createBusinessCategory: `${onboardingUrl}/Business/CreateBusinessCategory`,
    updateBusinessCategoryGroup: `${onboardingUrl}/Business/UpdateBusinessCategoryGroup`,
    createBusinessAccount: `${onboardingUrl}/Business/CreateBusinessAccount`,
    businessDocUpdate: `${onboardingUrl}/Business/UploadFile`,
    verifyCACAsync: `${onboardingUrl}/KYC/verify-cac-async`,
    verifyTINAsync: `${onboardingUrl}/KYC/verify-tin-async`,
    uploadBusinessOwnerFile: `${onboardingUrl}/KYC/UploadBusinessOwnerFile`,
    updateBusinessDetails: `${onboardingUrl}/Business/UpdateBusinessDetails`,
    getDirectorsAndShareholders: `${kycUrl}/kyc/verification/get-directors-and-shareholders`,
    createProprietor: `${kycUrl}/kyc/proprietor/create`,
    updateProprietor: `${kycUrl}/kyc/proprietor/update`,
    deleteProprietor: `${kycUrl}/kyc/proprietor/delete`,
    createDirector: `${kycUrl}/kyc/director/create`,
    updateDirector: `${kycUrl}/kyc/director/update`,
    deleteDirector: `${kycUrl}/kyc/director/delete`,
    createShareholder: `${kycUrl}/kyc/shareholder/create`,
    updateShareholder: `${kycUrl}/kyc/shareholder/update`,
    deleteShareholder: `${kycUrl}/kyc/shareholder/delete`,
    inviteNominee: `${onboardingUrl}/Nominee/InviteNominee`,
    sendBusinessOwnerConsentEmail: `${onboardingUrl}/Nominee/SendBusinessOwnerConsentEmail`,
    sendDirectorsConsentEmail: `${onboardingUrl}/Nominee/SendDirectorsConsentEmail`,
    getDirectorsConsent: `${onboardingUrl}/Nominee/GetDirectorsConsent`,
    getBusinessOwnersConsent: `${onboardingUrl}/Nominee/GetBusinessOwnersConsent`,
    fetchInvitedNominees: `${onboardingUrl}/Nominee/SearchNomineeInvite`,
    retrieveOwnerConsentWithToken: `${onboardingUrl}/Nominee/RetrieveOwnerConsentWithToken`,
    uploadBusinessOwnerSignature: `${onboardingUrl}/Nominee/UploadBusinessOwnerSignature`,
    initiateLegalFeePayment: `${onboardingUrl}/Business/InitiatePaymentWithCardTransactionForLegalSearchFee`,
    verifyLegalFeePayment: `${onboardingUrl}/Business/VerifyPaymentWithCardTransactionForLegalSearchFee`,
    processBusinessOwnerBVN: `${onboardingUrl}/User/ProcessBusinessOwnerBVN`,
    fetchInvitedSignatory: `${onboardingUrl}/Nominee/ValidateNomineeInvite`,
    sendValidationTokenForBusinessEmails: `${onboardingUrl}/Business/SendEmailOtpForBusinessEmailVerification`,
    acceptTerms: `${onboardingUrl}/Nominee/AcceptTerms`,
    cardConfig: "/Card/Config",

    // PASSKEY
    getPasskeyOptions: `${onboardingUrl}/Passkey/GetPasskeyOptions`,
    getPasskeysAsync: `${onboardingUrl}/Passkey/GetPasskeysAsync`,
    createPasskeyOptions: `${onboardingUrl}/Passkey/CreatePasskeyOptions`,
    createPasskey: `${onboardingUrl}/Passkey/CreatePasskey`,
    validatePasskey: `${onboardingUrl}/Passkey/ValidatePasskey`,
    revokePasskey: `${onboardingUrl}/Passkey/RevokePasskey`,

    smeProfileUpdate: "/SMEProfile/Update",
    smeUploadFile: "/SMEProfile/UploadFile",
    createPin: "/Signatory/CreatePIN",
    createWithExistingAccInfo: "/SMEProfile/CreateWithExistingAccountInformation",
    fetchUserAccountBalance: "/SMEProfile/GetAccountBalance",
    fetchBankFeeTransferCount: "/SMEProfile/InterBankFreeTransferCount",
    inviteSignatory: "/Signatory/InviteSignatory",
    validateCustomerSignupEmail: "User/confirm_retail_email",
    validateSignupToken: "User/ValidateEmailToken",
    // ---=-v2-------------- //
    getAccountBalance: `${onboardingUrl}/Business/GetAccountBalance`,
    fetchTeammates: `${onboardingUrl}/Nominee/SearchNominees`,
    addTeammate: `${onboardingUrl}/Nominee/InviteNominee`,
    updateNomineeDetaila: `${onboardingUrl}/Nominee/UpdateNomineeAccessLevel`,
    getTerminal: "/Sell/GetTerminal",

    // PAYMENTS
    processNameEnquiry: `${transferBaseUrl}/Transaction/ProcessNameEnquiry`,
    processBulkNameEnquiry: `${transferBaseUrl}/Transaction/ProcessBulkNameEnquiry`,
    InitiateTransfer: `${transferBaseUrl}/Transaction/InitiateTransfer`,
    processBulkTransfer: `${transferBaseUrl}/Transaction/ProcessBulkPayment`,
    ProcessTransfer: `${transferBaseUrl}/Transaction/ProcessTransfer`,
    createPaymentSchedule: `${transferBaseUrl}/Transaction/CreatePaymentSchedule`,
    initiateBulkTransfer: `${transferBaseUrl}/Transaction/InitiateBulkTransfer`,
    processBulkNameInquiry: `${transferBaseUrl}/Transaction/ProcessBulkNameEnquiry`,
    retrieveBillToken: `${transferBaseUrl}/billpayment/RetrieveBillToken`,

    searchFutureScheduledTransactions: `${transferBaseUrl}/Transaction/SearchFutureScheduledTransactions`,
    cancelFutureScheduledTransactions: `${transferBaseUrl}/Transaction/CancelFutureScheduledTransactions`,
    deletePaymentSchedule: `${transferBaseUrl}/Transaction/DeletePaymentSchedule`,
    getPaymentHistory: `${transferBaseUrl}/Transaction/SearchScheduledTransactions`,
    retryPaymentSchedule: `${transferBaseUrl}/Transaction/RetryPaymentSchedule`,
    fetchUserTransactions: `${transferBaseUrl}/Transaction/FetchTransactions`,
    searchTransactionTags: `${transferBaseUrl}/Transaction/SearchTransactionTags`,
    fetchTransactionHistoryByDateRange: `${transferBaseUrl}/Transaction/FetchTransactionHistoryByDateRangeWithPages`,

    payBills: `${transferBaseUrl}/BillPayment/PayBills`,
    getBillers: `${transferBaseUrl}/BillPayment/RetrieveBillers`,
    initiateAirtimePurchase: `${transferBaseUrl}/BillPayment/InitiateAirtimePurchase`,
    purchaseAirtime: `${transferBaseUrl}/BillPayment/PurchaseAirtime`,
    initiateBillPayment: `${transferBaseUrl}/BillPayment/InitiateBillPayment`,
    getBillerTypes: `${transferBaseUrl}/BillPayment/RetrieveBillerTypes`,
    getBillerDetails: `${transferBaseUrl}/BillPayment/RetrieveBillerDetails`,

    requestApproval: `${transferBaseUrl}/Approval/RequestApproval`,
    getAllApprovals: `${transferBaseUrl}/Approval/GetApprovals`,
    approveTransaction: `${transferBaseUrl}/Approval/ApproveTransaction`,

    getBeneficiaries: `${transferBaseUrl}/Beneficiary/Search`,
    createBenefeciary: `${transferBaseUrl}/Beneficiary/Create`,
    deleteBeneficiary: `${transferBaseUrl}/Beneficiary/Delete`,
    editBeneficiary: `${transferBaseUrl}/Beneficiary/Edit`,

    // SME PROFILE
    updateSMEProfile: "/SMEProfile/Update",
    fetchInvitedSignatoryV1: "/Signatory/ValidateInvitedSignatory",
    fetchAllSignatories: "/Signatory/Search",
    createWithUser: "/Signatory/CreateWithUser",
    createWithoutUser: "/Signatory/Create",

    validateKYC: "/SMEProfile/ValidateKYC",
    getDefaultPin: "/Card/GetCustomerCardDefaultPIN",
    updateSignatory: "/Signatory/Update",
    deleteSignatory: "/Signatory/Delete",
    searchSMEProfile: "/SMEProfile/Search",
    addShareholders: "/SMEProfile/ShareHolders/Add",
    getAccountStatementv1: "/SMEProfile/GetAccountStatement",
    sendBusinessValidationEmail: "SMEProfile/SendBusinessValidationEmail",
    updateBusinessEmail: "/SMEProfile/UpdateBusinessEmail",
    getBusinessInfo: "/Common/Business/info",
    updateBusinessType: "/SMEProfile/UpdateCategory",
    updateBusinessAddress: "/SMEProfile/UpdateBusinessAddress",
    chargeForLegalSearch: "/Business/ChargeForLegalSearch",

    //----V2 GROUP UPDATES------//
    updateBusinsessCategory: "/Business/UpdateBusinessCategory",
    deleteTeammate: `${onboardingUrl}/Nominee/RemoveNomineeFromGroup`,
    verifyBusinessEmailToken: "/Business/VerifyEmailOtpAndUpdateBusinessEmail",

    // PIN RESET
    updateTransactionPinv1: "/Signatory/ChangePIN",
    initiatePinResetv1: "/Signatory/InitiatePINReset",
    validateAndResetPinv1: "/Signatory/ValidateTokenAndResetPIN",
    createKudaAccount: "/SMEProfile/CreateWithNewKudaAccount",

    getTransactionLimits: "/SMEProfile/TransactionLimit/GetAll",
    fetchInvitedSignatories: "/Signatory/FetchInvitedSignatories",
    updateStatus: "/Signatory/UpdateStatus",
    initiateSetPin: "/Signatory/InitiateSetPIN",
    updateSignatoryStatus: "/Signatory/UpdateSignatoryStatus",
    //--V2 PIN ENDPOINT--//
    createTransactionPin: `${onboardingUrl}/Nominee/SetTransactionPin`,
    initiatePinReset: `${onboardingUrl}/Nominee/SendResetPinValidationOtp`,
    getAccountStatement: `${onboardingUrl}/Business/GetAccountStatement`,
    validateAndResetPin: `${onboardingUrl}/Nominee/ValidateTokenAndResetTransactionPin`,
    updateTransactionPin: `${onboardingUrl}/Nominee/ChangeTransactionPin`,

    // CARD
    getCustomerCards: "/Card/Get",
    getCustomerCardsBulk: "/Card/Get/Bulk",
    createCard: "/Card/Create",
    activateCard: "/Card/Activate",
    deactivateCard: "/Card/Deactivate",
    blockCard: "/Card/Block",
    unblockCard: "/Card/Unblock",
    changeCardLimit: "/Card/ChangeLimit",
    manageChannel: "/Card/ManageChannel",
    getCardPin: "/Card/GetPin",
    changeCardPin: "/Card/ChangePin",
    getCardDeliveryCharges: "/Card/GetCardDeliveryCharges",

    // INVOICING
    // ------ Invoice  ---------------
    getDashboardSummary: "/Invoice/GetDashboardSummary",
    getInvoiceSummaryByDateRange: "/Invoice/GetInvoiceStatsByDateRange",
    sendInvoice: "/Invoice/SendInvoice",
    getInvoice: "/Invoice/GetInvoice",
    getInvoices: "/Invoice/GetInvoices",
    searchInvoice: "/Invoice/SearchInvoice",
    createInvoice: "/Invoice/CreateInvoice",
    updateInvoice: "/Invoice/UpdateInvoice",
    deleteInvoice: "/Invoice/DeleteInvoice",

    // ------ Drafts  --------------------
    createDraft: "/Invoice/CreateDraft",
    updateDraft: "/Invoice/UpdateDraft",
    searchDrafts: "/Invoice/SearchDrafts",
    deleteDraft: "/Invoice/DeleteDraft",
    getDrafts: "/Invoice/GetDrafts",
    getDraft: "/Invoice/GetDraft",

    // -------- Estimates ------------

    getEstimates: "/Estimate/GetEstimates",
    getEstimate: "/Estimate/GetEstimate",
    deleteEstimate: "/Estimate/DeleteEstimate",
    extendEstimate: "/Estimate/ExtendExpirationDate",
    createEstimate: "/Estimate/CreateEstimate",
    getEstimateSummary: "/Estimate/GetEstimateSummaries",
    // ------ Customers  --------------
    searchInvoiceCustomer: "/Invoice/GetCustomers",
    createInvoiceCustomer: "/Invoice/CreateCustomer",
    updateInvoiceCustomer: "/Invoice/UpdateCustomer",
    deleteInvoiceCustomer: "/Invoice/DeleteCustomer",
    getSingleCustomer: "/Invoice/GetCustomer",
    // ------ Inventory  --------------
    searchInventory: "/Invoice/GetInventories",
    createInventoryItem: "/Invoice/CreateInventory",
    updateInventoryItem: "/Invoice/UpdateInventory",
    deleteInventoryItem: "/Invoice/DeleteInventory",
    // ------ Settings  --------------
    // searchSettings: "/Invoice/SearchInvoiceSetting",
    searchSettings: "/Invoice/GetSettings",
    createSettings: "/Invoice/CreateSettings",
    updateSettings: "/Invoice/UpdateSettings",

    // ------ Invoice Settlement -----------
    offlineSettlement: "/Invoice/OfflineSettlement",
    sendReminder: "/Invoice/SendPaymentReminder",
    getPaymentSummaries: "/Invoice/GetInvoicePaymentSummaries",
    updateSignatoryAddressV1: "/User/UpdateSignatoryAddress",

    // MONO
    monoInitiatePayment: "/Mono/initiate-payment",
    monoVerifyPaymentStatus: "/Mono/verify-payment-status",

    //------ Dashboard Redesign Endpoints ---------
    dailyTransferVolume: `${onboardingUrl}/Business/GetDailyTransactionVolume`,
    transferLimitSettings: `${onboardingUrl}/Business/GetTransferLimitSettings`,
    netCashAnalytics: `${onboardingUrl}/Business/GetNetCashAnalytics`,
    setTransactionLimit: `${onboardingUrl}/Business/IncreaseAccountLimit`,
    validateTransactionPinAndSendEmailOTP: `${onboardingUrl}/Business/ValidateTransactionPinAndSendEmailOTP`,
    increaseSingleTransactionLimit: `${onboardingUrl}/Business/IncreaseSingleAccountLimit`,

    //Freshchat ----------
    storeRestoreId: "/FreshDesk/SaveRestoreID",

    //------ Business Registration (NOREBASE) ---------
    businessRegistrationInit: "/BusinessRegistration/application-initialization",
    updateBusinessNameApplication: "/BusinessRegistration/business-name-application-update",
    updateCompanyRegistrationApplication:
        "/BusinessRegistration/company-incorporation-application-update",
    uploadBusinessRegistrationDocument: "/BusinessRegistration/document-upload",
    getBusinessNameApplication: "/BusinessRegistration/get-business-name-application",
    getCompanyRegistrationApplication:
        "/BusinessRegistration/get-company-incorporation-application",
    getBusinessRegistrationDocuments: "/BusinessRegistration/get-document",
    getBusinessRegistrationOnboardingDetails: "/BusinessRegistration/get-onboarded-user",
    businessRegistrationOnboarding: "/BusinessRegistration/onboarding",
    businessRegistrationInitiatePayment: "/BusinessRegistration/initiate-payment",
    cancelBusinessRegistration: "/BusinessRegistration/cancel-application",

    // --------------PAYROLL---------------------
    payroll: "/Payroll",
    payrollLogin: "/Payroll/login",
    payrollRevokeConsent: "/Payroll/revoke-consent",
    payrollCompleteConsent: "/Payroll/complete-consent",
    payrollConsent: "/Payroll/consent",
    payrollConfirmConsent: "/Payroll/confirm-consent",
    payrollPauseConsent: "/Payroll/pause-consent",

    // -------------Subaccounts -------------------

    createBusinessSubAccount: `${onboardingUrl}/User/CreateBusinessSubAccount`,
    getBusinessSubAccounts: `${onboardingUrl}/User/FetchSubAccounts`,
    closeBusinessSubAccount: `${onboardingUrl}/User/CloseSubAccount`,
};

export const businessRegistrationUrls = {
    post: {
        onboarding: `${norebaseUrl}/onboarding`,
        init: `${norebaseUrl}/application/init`,
        submit: `${norebaseUrl}/application/submit`,
        updateBusinessName: `${norebaseUrl}/application/update/bn`,
        updateCompanyRegistration: `${norebaseUrl}/application/update/llc`,
        uploadDocument: `${norebaseUrl}/document/upload`,
        initiatePayment: `${norebaseUrl}/application/initiate-payment`,
        cancelApplication: `${norebaseUrl}/application/cancel-application`,
    },
    get: {
        businessNameApplication: `${norebaseUrl}/application/get/bn`,
        companyRegistrationApplication: `${norebaseUrl}/application/get/llc`,
        document: `${norebaseUrl}/application/get/documents`,
        onboarding: `${norebaseUrl}/onboarding/get`,
        verifyPayment: `${norebaseUrl}/verifypayment/get`,
    },
};

export const businessRegistrationV2Urls = {
    getAllRecords: `${businessRegistrationBaseUrl}/business-requests`,
    getSingleRecord: `${businessRegistrationBaseUrl}/business-request`,
    getSpecificNatureOfBusiness: `${businessRegistrationBaseUrl}/specfic-business-nature-lookup`,
    updateBusinessOwners: `${businessRegistrationBaseUrl}/business-owner`,
    updateBusinessDetails: `${businessRegistrationBaseUrl}/business-details`,
    initiateBusinessRegistration: `${businessRegistrationBaseUrl}/initiation`,
    nameSearch: `${businessRegistrationBaseUrl}/name-search`,
    lookup: `${businessRegistrationBaseUrl}/lookup`,
    payment: `${businessRegistrationBaseUrl}/payment`,
    confirmTransfer: `${businessRegistrationBaseUrl}/dva-tsq`,
    deleteApplication: `${businessRegistrationBaseUrl}/delete`,
    validate: `${businessRegistrationBaseUrl}/validate`,
    logValidation: `${businessRegistrationBaseUrl}/log-validation`,
    stateLookup: `${businessRegistrationBaseUrl}/state-lookup`,
    lgaLookup: `${businessRegistrationBaseUrl}/lga-lookup`,
};

export const openApiUrls = {
    // accounts
    onBoardK4BAccount: `${openApiBaseUrl}/api/K4b/Account/OnBoardK4BAccount`,
    getClientDetails: `${openApiBaseUrl}/api/k4b/APIClient/GetClientDetails`,
    goLiveUrl: `${openApiBaseUrl}/api/k4b/APIClient/golive`,
    updateClientDetails: `${openApiBaseUrl}/api/k4b/APIClient/UpdateClient`,
    updateLive: `${openApiBaseUrl}/api/k4b/APIClient/updatelive`,

    // api activation
    getApiProductRoles: `${openApiOnboardingBaseUrl}/GetRoles`,
    createOpenApiAccount: `${openApiOnboardingBaseUrl}/CreateOpenApiAccount`,
    updateOpenApiAccount: `${openApiOnboardingBaseUrl}/UpdateOpenApiAccount`,
    uploadApiFile: `${openApiOnboardingBaseUrl}/UploadFile`,
    getApiProfile: `${openApiOnboardingBaseUrl}/FetchOpenApiProfile`,

    // subaccounts
    getSubAccountCreated: `${openApiBaseUrl}/api/k4b/Dashboard/getSubaccountCreated`,
    getSubAccounts: `${openApiBaseUrl}/api/k4b/Dashboard/getsubaccounts`,
    getSearchSubAccounts: `${openApiBaseUrl}/api/k4b/Dashboard/SearchSubAccount`,
    getSubAccountsTransactions: `${openApiBaseUrl}/api/k4b/Dashboard/getsubaccounttransactions`,
    getFilteredSubAccountTransactions: `${openApiBaseUrl}/api/k4b/Dashboard/getfilteredsubaccounttransactions`,
    getSubAccountBalance: `${openApiBaseUrl}/api/k4b/Dashboard/getvirtualaccountbalance`,
    resendWebhook: `${openApiBaseUrl}/api/k4b/Dashboard/ResendWebhook`,

    // api keys
    generateClientApiKey: `${openApiBaseUrl}/api/k4b/APIClient/GenerateClientApiKey`,
    updateClientTokenExpiry: `${openApiBaseUrl}/api/k4b/APIClient/UpdateClientTokenExpiry`,
    getClientTokenExpiry: `${openApiBaseUrl}/api/k4b/APIClient/GetClientTokenExpiryTime`,

    // Test console
    testConsole: `${openApiBaseUrl}/api/k4b/TestConsole/test`,

    // Settings
    setVirtualAccountLimit: `${openApiBaseUrl}/api/k4b/Dashboard/SetVirtualAccountDailyInterbankLimit`,
    getVirtualAccountLimit: `${openApiBaseUrl}/api/k4b/Dashboard/GetVirtualAccountTransactionLimit`,
    getVirtualStatement: `${openApiBaseUrl}/api/k4b/Dashboard/getstatement`,
    updateWebhookUrl: `${openApiBaseUrl}/api/k4b/APIClient/updateWebHookUrl`,
    updateBillWebhookUrl: `${openApiBaseUrl}/api/k4b/APIClient/UpdateBillWebHookUrl`,
};

export const payrollBaseUrl = `${process.env.REACT_APP_GATEWAY_BASE_URL}/payroll/api/v1`;

export const payrollUrls = {
    // onboarding
    onboardPayroll: `${payrollBaseUrl}/Onboard`,
    setPayrollConfiguration: `${payrollBaseUrl}/Onboard/payroll-configuration`,
    getPayrollConfiguration: `${payrollBaseUrl}/Onboard/payroll-configurations`,
    completeOnboarding: `${payrollBaseUrl}/Onboard/complete-onboarding`,

    // employees
    addSingleEmployee: (profileId) => `${payrollBaseUrl}/${profileId}/Employee`,
    deleteEmployee: (profileId) => `${payrollBaseUrl}/${profileId}/Employee/delete`,
    verifyBulkEmployee: (profileId) =>
        `${payrollBaseUrl}/${profileId}/Employee/verify-bulk-employee`,
    addBulkEmployee: (profileId) => `${payrollBaseUrl}/${profileId}/Employee/bulk-employee`,
    getEmployees: (profileId) => `${payrollBaseUrl}/${profileId}/Employee/employees`,
    editEmployee: (profileId) => `${payrollBaseUrl}/${profileId}/Employee/edit-employee`,

    // schedules
    getAllSchedules: (profileId) =>
        `${payrollBaseUrl}/${profileId}/PayrollSchedule/get-all-schedules`,
    updateSchedule: (profileId) => `${payrollBaseUrl}/${profileId}/PayrollSchedule/update-schedule`,
    addSchedule: (profileId) => `${payrollBaseUrl}/${profileId}/PayrollSchedule/add-schedule`,
    getEmployeesWithoutSchedule: (profileId) =>
        `${payrollBaseUrl}/${profileId}/PayrollSchedule/get-all-employees-without-schedule`,
    editSchedule: (profileId) => `${payrollBaseUrl}/${profileId}/PayrollSchedule/edit-all-schedule`,
    resetSchedule: (profileId) =>
        `${payrollBaseUrl}/${profileId}/PayrollSchedule/reset-all-schedule`,
    deleteAllSchedule: (profileId) =>
        `${payrollBaseUrl}/${profileId}/PayrollSchedule/delete-all-schedule`,
    deleteSomeSchedule: (profileId) =>
        `${payrollBaseUrl}/${profileId}/PayrollSchedule/delete-bulk-schedules`,

    // payroll run
    confirmPayrollRun: (profileId) =>
        `${payrollBaseUrl}/${profileId}/PayrollProcessing/confirm-payroll`,
    runPayroll: (profileId) => `${payrollBaseUrl}/${profileId}/PayrollProcessing`,
    payrollHistory: (profileId) => `${payrollBaseUrl}/${profileId}/PayrollProcessing/history`,
    payrollHistoryDetails: (profileId, historyId) =>
        `${payrollBaseUrl}/${profileId}/PayrollProcessing/${historyId}`,
    retryFailedPayroll: (profileId) =>
        `${payrollBaseUrl}/${profileId}/PayrollProcessing/retry-failed`,
    cancelPayrollRun: (profileId) => `${payrollBaseUrl}/${profileId}/PayrollProcessing/cancel`,
    runPayrollNow: (profileId) => `${payrollBaseUrl}/${profileId}/PayrollProcessing/disburse-now`,

    // status
    payrollConfirmConsent: "/Payroll/confirm-consent",
};

const payoneerBaseUrl = `${process.env.REACT_APP_GATEWAY_BASE_URL}/international-payment/api/v1/Payoneer`;

export const payoneerUrls = {
    getAccountStatus: `${payoneerBaseUrl}/GetAccountStatus`,
    getOnboardingUri: `${payoneerBaseUrl}/GenerateOnboardingUri`,
    generateLinkAccountUri: `${payoneerBaseUrl}/GenerateLinkAccountUri`,
    linkPayoneerUserToKuda: `${payoneerBaseUrl}/LinkAccount`,
    updateAccountStatus: `${payoneerBaseUrl}/UpdateAccountStatus`,
    unlinkPayoneerAccount: `${payoneerBaseUrl}/UnlinkAccount`,

    getAccountBalances: `${payoneerBaseUrl}/GetAccountBalances`,
    getTransactionHistory: `${payoneerBaseUrl}/GetTransactionHistory`,
    initiateWithdrawal: `${payoneerBaseUrl}/InitiateWithdrawal`,
    commitTransaction: `${payoneerBaseUrl}/CommitTransaction`,
    getReceivingAccounts: `${payoneerBaseUrl}/GetReceivingAccounts`,
    createReceivingAccount: `${payoneerBaseUrl}/CreateReceivingAccount`,
};

const posBaseUrl = `${process.env.REACT_APP_GATEWAY_BASE_URL}/pos/api/v1`;

export const posUrls = {
    getVirtualPosTerminals: `${posBaseUrl}/virtual/getterminal`,
    getHardwarePosTerminals: `${posBaseUrl}/hardware/get`,
    getHardwareTerminalRequests: `${posBaseUrl}/hardware/getterminalrequests`,
    activateHardwarePosTerminal: `${posBaseUrl}/hardware/activate`,
    sweepTerminal: `${posBaseUrl}/terminal/sweep`,
    sweepHistory: `${posBaseUrl}/terminal/sweephistory`,
    restrictVirtualTerminal: `${posBaseUrl}/virtual/restrict`,
    changeVirtualTerminalNotificationEmail: `${posBaseUrl}/virtual/changenotificationemail`,
    purchaseHardwarePosTerminal: `${posBaseUrl}/hardware/purchaseterminal`,
    createVirtualTerminal: `${posBaseUrl}/virtual/createterminal`,
    checkTerminalOnboardingStatus: `${posBaseUrl}/terminal/check`,
    updatePhysicalTerminalNotification: `${posBaseUrl}/hardware/notification/update`,
    verifyTerminalPurchasePayment: `${posBaseUrl}/hardware/verifypayment`,
};

const creditBaseUrl = `/credit`;

export const creditUrls = {
    salaryAdvanceOptIn: `${creditBaseUrl}/salary-advance-opt-in`,
};

const catalogueBaseUrl = `${process.env.REACT_APP_GATEWAY_BASE_URL}/catalog/api/v1`;

export const catalogueUrls = {
    catalogueItem: `${catalogueBaseUrl}/Item`,
    catalogueCategory: `${catalogueBaseUrl}/Category`,
    editCatalogueItem: `${catalogueBaseUrl}/Item/Update`,
    deleteCatalogueItem: (ownerId, id) => `${catalogueBaseUrl}/Item/${ownerId}/${id}`,
    editCategory: `${catalogueBaseUrl}/Category/Update`,
    deleteCategory: (ownerId, id) => `${catalogueBaseUrl}/Category/${ownerId}/${id}`,
    activationStatus: `${catalogueBaseUrl}/activate`,
    createOrder: `${catalogueBaseUrl}/Order`,
    deleteOrder: (ownerId, id) => `${catalogueBaseUrl}/Order/${ownerId}/${id}`,
    updateSalesOrder: `${catalogueBaseUrl}/Order/Update`,
    checkoutOrder: `${catalogueBaseUrl}/Order/Checkout`,
    orderHistory: `${catalogueBaseUrl}/Order`,

    // customers for invoicing
    customer: `${catalogueBaseUrl}/Customer`,
    deleteCustomer: (ownerId, id) => `${catalogueBaseUrl}/Customer/${ownerId}/${id}`,
    updateCustomer: `${catalogueBaseUrl}/Customer/Update`,
};

const salesBaseUrl = `${process.env.REACT_APP_GATEWAY_BASE_URL}/pos/api/v2/sell`;

export const salesUrls = {
    generateSalesToken: `${salesBaseUrl}/onboardselldevice`,
    getSalesDevices: `${salesBaseUrl}/searchselltoken`,
    deleteSalesDevice: `${salesBaseUrl}/Deletesellmodeterminal`,
    deactivateSalesDevice: `${salesBaseUrl}/deactivatesellmodeterminal`,
    reactivateSalesDevice: `${salesBaseUrl}/reactivatesellmodeterminal`,
    validateToken: `${salesBaseUrl}/validatetoken`,
    refreshSalesToken: `${salesBaseUrl}/RefreshSellToken`,
};

// Invoicing V2
const invoicingBaseUrl = `${process.env.REACT_APP_GATEWAY_BASE_URL}/invoice`;

export const invoicingUrls = {
    createInvoice: `${invoicingBaseUrl}/Invoice/Create`,
    updateInvoice: `${invoicingBaseUrl}/Invoice/Update`,
    getInvoiceSummary: `${invoicingBaseUrl}/Invoice/GetInvoiceSummaries`,
    getSettings: `${invoicingBaseUrl}/Settings/GetSetting`,
    createSettings: `${invoicingBaseUrl}/Settings/Create`,
    updateSettings: `${invoicingBaseUrl}/Settings/Update`,
    sendInvoice: `${invoicingBaseUrl}/Invoice/SendInvoice`,
    getDashboardSummary: `${invoicingBaseUrl}/api/Dashboard/Summary`,
    getInvoices: `${invoicingBaseUrl}/Invoice/GetInvoices`,
    getInvoice: `${invoicingBaseUrl}/Invoice/GetInvoice`,
    downloadPdf: (refId) => `${invoicingBaseUrl}/PdfGenerator/Download/${refId}`,
    offlineSettlement: `${invoicingBaseUrl}/Invoice/OfflineSettlement`,
    deleteInvoice: `${invoicingBaseUrl}/Invoice/Delete`,
    sendPaymentReminder: `${invoicingBaseUrl}/Invoice/SendPaymentReminder`,
    activateInvoice: `${invoicingBaseUrl}/api/Dashboard/Activate`,
    getInvoiceStatus: `${invoicingBaseUrl}/api/Dashboard/GetActivation`,
    getInvoiceSummaryByDateRange: `${invoicingBaseUrl}/api/Dashboard/Summary/date_range`,
};
